<div class="import-stepper submit-stepper">
    <button mat-icon-button class="close-btn" (click)="onCloseClick()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-stepper [linear]="true" #stepper>
      <mat-step disableRipple>
        <ng-template matStepLabel>Validate Report</ng-template>
        <div class="content-body">
          <app-validate-report [recordId]="recordId" [accountingPeriodId]="accountingPeriodId"></app-validate-report>
        </div>
      </mat-step>
      <mat-step disableRipple>
        <ng-template matStepLabel>Verify Report</ng-template>
        <div class="content-body">
          <app-view-report [fileDetails]="fileDetails"></app-view-report>
          <!-- <div id="report-container"  *ngIf="fileDetails"  [innerHTML]="fileDetails | viewHtmlContent"></div> -->
        </div>
      </mat-step>
      <mat-step disableRipple>
        <ng-template matStepLabel>Gateway Details</ng-template>
        <div class="content-body">
          <app-gateway-detail [gatewayDetails]="gatewayDetails" [recordId]="recordId"></app-gateway-detail>
        </div>
      </mat-step>
      <mat-step disableRipple>
        <ng-template matStepLabel>Submit Accounts</ng-template>
        <div class="content-body">
          <app-submit-account [submitAccountDetails]='submitAccountDetails' [gatewayDetails]="gatewayDetails" [recordId]="recordId"></app-submit-account>
        </div>
      </mat-step>
    </mat-stepper>
  </div>

  <div class="action-wrapper button-action-wrapper">
    <div class="content-body">
      <button
        class="action-button secondary-button mr-1"
        type="button"
        mat-button
        disableRipple
        (click)="goPrevious()" [disabled]="stepper.selectedIndex === 0"
      >
        Prev
      </button>
      <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        [disabled]="child.isErroeExit"
        (click)="stepper.selectedIndex === stepper.steps.length - 1 ? onSaveClick() : goNext()"
      >
        {{stepper.selectedIndex === stepper.steps.length - 1 ? 'Submit' : 'Next'}}
      </button>
    </div>
  </div>